import { apiUrl } from "@/lib/api";

interface Props {
  mode: "login" | "signup";
  tenantName?: string;
  redirect?: string;
  label?: string;
}

export function GoogleSignInButton({ mode, tenantName, redirect, label }: Props) {
  const params = new URLSearchParams({ mode });
  if (mode === "signup" && tenantName) params.set("tenantName", tenantName);
  if (redirect) params.set("redirect", redirect);

  const href = apiUrl(`/v1/auth/google/start?${params.toString()}`);

  return (
    <a
      href={href}
      className={
        "group inline-flex h-9 w-full items-center justify-center gap-2 rounded-md " +
        "border border-zinc-200 bg-white px-3 text-[13.5px] font-medium text-zinc-800 " +
        "transition hover:border-zinc-300 hover:bg-zinc-50 active:bg-zinc-100 " +
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-500 focus-visible:ring-offset-white " +
        "dark:border-zinc-800 dark:bg-zinc-900/60 dark:text-zinc-100 dark:hover:border-zinc-700 dark:hover:bg-zinc-900 dark:active:bg-zinc-800 dark:focus-visible:ring-offset-zinc-950"
      }
    >
      <GoogleGlyph />
      {label ?? (mode === "signup" ? "Continue with Google" : "Sign in with Google")}
    </a>
  );
}

function GoogleGlyph() {
  return (
    <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.4 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.6 39.5 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.7l6.2 5.2C40.9 36 44 30.5 44 24c0-1.2-.1-2.4-.4-3.5z"
      />
    </svg>
  );
}
